import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CFRD_SUPERVISORS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/cfrd/supervisors/")({
  component: () => <DeptContentList cfg={CFRD_SUPERVISORS} />,
});
